import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('old.form.editors.dateTime.DateTimeEditor', {
    clearButtonTitle: 'Clear field',
});
